import { useQuery } from "@tanstack/react-query";

import { COUNTRY_CACHE_KEYS } from "./keys";

import { CountryRepository } from "@/repositories/country";

const countryRepository = new CountryRepository();

export const useGetAllCountries = () => {
  return useQuery({
    queryKey: COUNTRY_CACHE_KEYS.LIST,
    queryFn: async () => {
      return await countryRepository.findAll();
    },
  });
};
